<div class="full-width">
  <app-metric-dimension-name [item]="inject.option.item"
                             [showCategory]="inject.type === 'reminder'"></app-metric-dimension-name>
</div>
